import { Component, Inject, Input, OnInit, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { UtilService, SeoService, VariablesService, CookieService, GalleryService, VwoService } from '../../../../shared/services';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-inner-templater',
  templateUrl: './inner-templater.component.html',
  styleUrls: ['./inner-templater.component.scss']
})
export class InnerTemplaterComponent implements OnInit, OnChanges {

  @Input() public innerHtml;
  @Input() public count;
  abt: any = false;
  @ViewChild('aboutTemp') public aboutTemp: ElementRef<HTMLElement>;
  constructor(
    @Inject(DOCUMENT) private document: any,
    public utilService: UtilService,
    private seoService: SeoService,
    private variablesService: VariablesService,
    private cookieService: CookieService,
    private galleryService: GalleryService,
    private vwo: VwoService
  ) { }

  ngOnInit() {
    // setTimeout(() => {
    //   this.setImageAttribute(this.innerHtml);
    // }, 0);
  }

  ngOnChanges() {
    setTimeout(() => {
      this.setImageAttribute(this.innerHtml);
    }, 0);
  }

  /**Add lazy load attributes(directive) to all image ellement */
  setImageAttribute(html) {
    const root = this.document.createElement('div');
    root.innerHTML = html;
    root.style.fontFamily = '"Source Sans Pro", sans-serif !important';
    this.setImages(root);
    this.setIframe(root);
    this.variablesService.thirdPartyApp ? this.removeFUndraiserLink(root) : this.setUtmsInKnowMoreLink(root);
    this.abt = root.innerHTML;
  }

  /**Set the UTM tags in the fundraiser link of story page */
  setUtmsInKnowMoreLink(root) {
    const aTags = root.getElementsByTagName('a');
    const utmParams = this.cookieService.getDecodedCookies('k_utm');
    if (utmParams) {
      Array.prototype.forEach.call(aTags, (item: HTMLAnchorElement) => {
        if (item.href.match('/fundraiser/')) {
          utmParams['utm_source'] = 'external_stories_knowmore';
          const url = new URL(item.href);
          for (const key of Object.keys(utmParams)) {
            url.searchParams.append(key, utmParams[key]);
          }
          item.href = url.href;
        }
      });
    }
  }

  /**Remove the fundraiser link if Phone pe present */
  removeFUndraiserLink(root) {
    const aTags = root.getElementsByTagName('a');
    Array.prototype.forEach.call(aTags, (item: HTMLAnchorElement) => {
      if (item.href.match('/fundraiser/')) {
        item.parentNode.removeChild(item);
      }
    });
  }

  /**Set the Images of the conent to lazy load
   * and some other modifications */
  setImages(root) {
    const images = root.getElementsByTagName('img');
    Array.prototype.forEach.call(images, (image: HTMLImageElement, i) => {
      image.style.margin = '5px auto';
      image.setAttribute('data-src', image.src);
      // image.removeAttribute('src');
      image.setAttribute('name', 'about_image');
      image.setAttribute('id', i);
      image.setAttribute('loading', 'lazy');
      image.style.maxWidth = '100%';
      image.style.height = 'auto';
      image.style.maxHeight = '400px';

      const imageAtag = this.document.createElement('a');
      const imageDiv = this.document.createElement('div');
      imageDiv.id = typeof this.count !== 'undefined' ? `lightgallery${i}${this.count}` : `lightgallery${i}`;
      const parent = image.parentNode;
      imageAtag.href = image.src;
      image.setAttribute('src', this.utilService.defaultImg);
      image.classList.remove('gm-loaded');
      parent.replaceChild(imageAtag, image);
      imageAtag.appendChild(image);
      imageAtag.parentNode.replaceChild(imageDiv, imageAtag);
      imageDiv.appendChild(imageAtag);
      image.addEventListener('load', (item: any) => {
        if (item.target?.parentElement?.parentElement) {
          this.galleryService.initGallery(item.target.parentElement.parentElement.id, {
            galleryId: this.count
          });
        }
      });
    });
  }

  /**Set the Iframes of the conent to lazy load
   * and some other modifications */
  setIframe(root) {
    const iframe = root.getElementsByTagName('iframe');
    Array.prototype.forEach.call(iframe, (item) => {
      item.style.maxWidth = '100%';
      item.setAttribute('src', item.src);
      if (this.variablesService.metaDataOfPage) {
        const data = {
          title: this.variablesService.metaDataOfPage.title,
          desc: this.variablesService.metaDataOfPage.description,
          videoId: this.utilService.getYouTubeId(item.src),
          startDate: this.variablesService.fundraiser.start_date
        };
        this.seoService.schamObjectForVideos(data);
      }
    });
  }

}
